import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable, Subject } from 'rxjs';
import { Api } from '../enum/Api';
import { serasaPublicData } from '../constants/one-constants';
import { map } from 'rxjs/operators';
import { Cart } from '../model/cart';

@Injectable({
  providedIn: 'root'
})
export class  CartService {

  cart: Cart;
  carts: Array<Cart>;
  origin: string;


  cartUpdated: Subject<any> = new Subject<any>();
  couponUpdated: Subject<any> = new Subject<any>();
  paymentMethodChanged: Subject<any> = new Subject<any>();
  paymentOptionChanged: Subject<any> = new Subject<any>();
  trustConsultationData: Subject<any> = new Subject<any>();
  allowAutomaticRechargeChange: Subject<any> = new Subject<any>(); // aplicar solução melhor durante a refatoração do código.	

  constructor(private httpService: HttpService) { }

  public getCurrentCart(): Cart {
    if (!this.cart && sessionStorage.getItem('cart')) {
      this.getSessionStorageCart();
    }

    return this.cart;
  }

  public setCart(cart: Cart) {
    this.cart = cart;
    this.saveCartOnSessionStorage();
    //this.cartUpdated.next(true);
  }

  public getCarts() {
    return this.carts;
  }

  public setCarts(carts: Array<Cart>) {
    this.carts = carts;
  }

  public anyCartHasValidAppliedCoupon() {
    return this.carts.some(cart => {
      return cart.couponIdentifier && cart.appliedDiscounts.length > 0;
    })
  }

  public getAnyCartCouponIdentifier() {
    const cartWithCoupon = this.carts.find(cart => cart.couponIdentifier);
    return cartWithCoupon && cartWithCoupon.couponIdentifier;
  }
  
  /** Funcao auxiliar para retornar carrinho por forma de pagamento - nao seta no this.cart */
  public getCartByPaymentMethod(paymentMethod: string): Cart {
    let cart = null;

    if (this.carts) {
      const cartFound = this.carts.find(cart => cart.paymentMethod.identifier === paymentMethod);

      if (cartFound) {
        cart = cartFound;
      }
    }

    return cart;
  }

  public setCartByPaymentMethod(paymentMethod: string) {
    const currentCart = this.carts.find(cart => cart.paymentMethod.identifier === paymentMethod);
    this.cart = currentCart;
    this.saveCartOnSessionStorage();
    this.cartUpdated.next(true);
  }

  public saveCartOnSessionStorage() {
    sessionStorage.setItem('cart', JSON.stringify(this.cart));
  }

  public getSessionStorageCart() {
    this.setCart(new Cart(JSON.parse(sessionStorage.getItem('cart'))));
  }

  public getSaleRetentionProduct(identifier: string): Observable<Cart> {
    return this.httpService.post('eCommercePME/eCommerceAPI/getSaleRetentionProduct', Api.One_Portal, {
      'productIdentifier': identifier
    }).pipe(map(result => new Cart(result)));
  }

  // TODO - Alterar retorno do ONE para formato Cart
  public getUpgradeProduct(contractCode: string) {
    return this.httpService.post('eCommercePME/eCommerceAPI/getUpgradeProducts', Api.One_Portal, {
      'contractCode': contractCode
    }).pipe(map(result => new Cart(result)));
  }

  public simulate(id: string, type: string, productIdentifier: string, saleStep: string,
    couponIdentifier?: Array<string>, userId?: string, businessId?: string,  retentionCount?: number, additionalData?: any, newPlan?: string): Observable<Array<Cart>> {
    const validationData = sessionStorage.getItem('validationData') || '{}';
    return this.httpService.post('eCommercePME/cart/simulate', Api.One_Portal, {
      '_id': id,
      'type': type,
      'productIdentifier': productIdentifier,
      'couponIdentifier': couponIdentifier || [],
      'userId': userId,
      'businessId': businessId,
      'retentionCount': retentionCount,
      'validationData': JSON.parse(validationData),
      'saleStep': saleStep,
      'additionalData': additionalData,
      'newPlan': newPlan,
      'isAdyen': sessionStorage.getItem('isAdyen') === 'true' ? true : false
    }).pipe(map(simulateResult => {
      let carts = [];
      if (simulateResult && simulateResult.carts) {
        simulateResult.carts.map(cart => carts.push(new Cart(cart)));
        this.origin = simulateResult.origin;
      }
      return carts;
    }));
  }

  /**
   * Loga um conteudo 'content' no log da aplicacao
   * @param content - String com o conteudo que sera logado
   */
  public log(content: string) {
    if (content) {
      this.httpService.post("eCommercePME/eCommerceAPI/log", Api.One_Portal, {
        "content": content
      }).subscribe(result => {});
    }
  }

  /** Adiciona um log de erro ao carrinho
   * @param id _id do carrinho
   * @param error conteudo do erro que sera adicionado ao carrinho
   */
  public logError(cartId: string, error: any) {
    return this.httpService.post("/eCommercePME/cart/logError", Api.One_Portal, {
      "_id": cartId,
      "errors": [error]
    });
  }
}
